import { URL } from '../../variables';
export async function integrationLogRequest(token, path = '', filters = {}) {
    const query = new URLSearchParams(filters).toString();
    const response = await fetch(`${URL}api/faculdade/integration-logs${path ? `/${path}` : ''}${query ? `?${query}` : ''}`, {
        headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || !data) {
        const error = new Error(Object.values(data?.errors || {}).flat().join(' ') || data?.message || 'Não foi possível carregar os logs.');
        error.status = response.status;
        throw error;
    }
    return data;
}
